import { AppState } from "./models";

export const genericCaseTypesSelector = (state: AppState) => {
    return state.genericCaseTypes;
};
